import {API_CONFIG} from '../contentGenerator/config';
import {apiFetch} from './apiFetch';

const EVENT_URL = `${API_CONFIG.PROXY_URL}/stats/events`;
const SUMMARY_URL = `${API_CONFIG.PROXY_URL}/stats/summary`;

const normalizeMetadata = (metadata = {}) => {
    if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return {};
    return Object.fromEntries(
        Object.entries(metadata)
            .filter(([key]) => key)
            .map(([key, value]) => [key, value]),
    );
};

async function parseApiResponse(response, fallbackMessage) {
    const contentType = response.headers.get('content-type') || '';
    const payload = contentType.includes('application/json')
        ? await response.json().catch(() => null)
        : await response.text().catch(() => '');

    if (!response.ok) {
        throw new Error(
            payload?.error ||
                payload?.message ||
                (typeof payload === 'string' && payload) ||
                fallbackMessage,
        );
    }

    return payload;
}

export async function trackUsageEvent(eventType, metadata = {}) {
    if (!eventType || typeof fetch !== 'function') return false;

    try {
        const response = await apiFetch(EVENT_URL, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                eventType,
                metadata: normalizeMetadata(metadata),
            }),
        });
        await parseApiResponse(response, 'Could not record usage event.');
        return true;
    } catch {
        return false;
    }
}

export async function loadUsageSummary({days = 30} = {}) {
    const response = await apiFetch(
        `${SUMMARY_URL}?days=${encodeURIComponent(days)}`,
    );
    return parseApiResponse(response, 'Could not load usage stats.');
}
